import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Video, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNewVideoModal } from '@/contexts/NewVideoModalContext';

export function EmptyVideoState() {
  useLanguage();
  // Abre o modal global de upload (GlobalUploadModal, montado no App fora das
  // rotas). Antes daqui saía um navigate('/novo-video') — rota que não existe:
  // o App só declara '/new-video', e mesmo essa é um redirect para '/'.
  const { openModal } = useNewVideoModal();

  return (
    <div className="flex items-center justify-center py-14 px-6 rounded-[12px] border border-dashed border-[#BCD0FA] bg-[#FBFCFE]">
      <div className="flex flex-col items-center text-center max-w-md">
        <div className="w-12 h-12 rounded-[12px] bg-[#EEF4FF] flex items-center justify-center mb-4">
          <Video className="w-6 h-6 text-[#3478F6]" strokeWidth={1.8} />
        </div>
        <h3 className="text-[15px] font-semibold text-[#101828] mb-1">
          {translateInterfaceText("Nenhum vídeo enviado ainda")}</h3>
        <p className="text-[12.5px] text-[#98A2B3] mb-5">
          {translateInterfaceText("Comece enviando seu primeiro vídeo para acompanhar métricas e performance.")}</p>
        <Button
          onClick={openModal}
          className="h-[38px] px-5 gap-2 rounded-[10px] bg-[#3478F6] hover:bg-[#2869E5] text-[13px] font-semibold shadow-none"
        >
          <Plus className="w-4 h-4" />
          {translateInterfaceText("Enviar meu primeiro vídeo")}</Button>
      </div>
    </div>
  );
}